/* Precision 1.3: native horizontal rails and collision avoidance. No cart or store data writes. */
(() => {
  'use strict';
  if (window.SenfinecoUsability13) return;
  const rails = new WeakSet();
  let buyTarget = null, buyObserver = null;
  const helpSelector = 'a[href*="wa.me/"],a[href*="api.whatsapp.com/"],a[href*="whatsapp.com/send"]';
  function markHelp(scope = document) {
    if (!scope?.querySelectorAll) return;
    const links = [...scope.querySelectorAll(helpSelector)];
    if (scope.matches?.(helpSelector)) links.push(scope);
    const parentLink = scope.closest?.(helpSelector);
    if (parentLink) links.push(parentLink);
    links.forEach(link => {
      if (!link.isConnected || link.closest('cart-drawer,.sf-oil-dialog,.sf-native-nav__panel')) return;
      let node = link;
      for (let i = 0; node && node !== document.body && i < 6; i++, node = node.parentElement) {
        if (getComputedStyle(node).position === 'fixed') { node.classList.add('sf26-floating-help'); break; }
      }
    });
  }
  function initRail(details) {
    if (rails.has(details)) return;
    const rail = details.querySelector('.sf26-brands-rail');
    const cards = rail ? [...rail.querySelectorAll('.sf26-brand')] : [];
    const prev = details.querySelector('[data-sf26-rail-prev]');
    const next = details.querySelector('[data-sf26-rail-next]');
    if (!rail || !cards.length || !prev || !next) return;
    rails.add(details);
    details.querySelector('.sf26-brands-controls').hidden = false;
    const isVisible = (card, bounds) => {
      const r = card.getBoundingClientRect();
      return r.left >= bounds.left - 3 && r.right <= bounds.right + 3;
    };
    let pending = false;
    const update = () => {
      pending = false;
      if (!details.open || !rail.clientWidth) return;
      const bounds = rail.getBoundingClientRect();
      prev.disabled = isVisible(cards[0], bounds);
      next.disabled = isVisible(cards[cards.length - 1], bounds);
    };
    const queue = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    const moveTo = index => {
      cards[Math.max(0, Math.min(cards.length - 1, index))].scrollIntoView({
        block: 'nearest', inline: 'start',
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      queue();
    };
    const move = direction => {
      const bounds = rail.getBoundingClientRect();
      let first = cards.findIndex(card => isVisible(card, bounds));
      if (first < 0) first = 0;
      const pageSize = Math.max(1, Math.floor(rail.clientWidth / (cards[0].getBoundingClientRect().width + 8)));
      moveTo(first + direction * pageSize);
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    details.addEventListener('toggle', queue);
    rail.addEventListener('scroll', queue, { passive: true });
    rail.addEventListener('keydown', event => {
      if (event.target !== rail) return;
      const rtl = getComputedStyle(rail).direction === 'rtl';
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault(); moveTo(event.key === 'Home' ? 0 : cards.length - 1);
      }
    });
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(rail);
    queue();
  }
  function bindBuy() {
    const target = document.querySelector('.template-product #MainContent .sf-commerce-buy');
    if (target === buyTarget) return;
    buyObserver?.disconnect(); buyTarget = target;
    document.body.removeAttribute('data-sf26-buy-visible');
    if (!target || !('IntersectionObserver' in window)) return;
    buyObserver = new IntersectionObserver(entries => {
      document.body.toggleAttribute('data-sf26-buy-visible', entries.some(entry => entry.isIntersecting));
    }, { threshold: 0 });
    buyObserver.observe(target);
  }
  function refresh(scope = document) {
    scope.querySelectorAll?.('[data-sf26-more-brands]').forEach(initRail);
    if (scope.matches?.('[data-sf26-more-brands]')) initRail(scope);
    markHelp(scope); bindBuy();
  }
  function start() {
    refresh();
    document.addEventListener('shopify:section:load', event => refresh(event.target));
    document.addEventListener('sf:inline-products-updated', () => refresh());
    addEventListener('pageshow', () => refresh());
    addEventListener('load', () => refresh(), { once: true });
    // Process newly inserted nodes only, not a whole-page scan on every mutation.
    const pendingRoots = new Set();
    let scheduled = false;
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1) pendingRoots.add(node);
      }
      if (!pendingRoots.size || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        for (const node of pendingRoots) if (node.isConnected) refresh(node);
        pendingRoots.clear();
      });
    }).observe(document.body, { childList: true, subtree: true });
    // Some support widgets become fixed shortly after their initial insertion.
    [600, 1800, 3500].forEach(delay => setTimeout(() => markHelp(), delay));
  }
  window.SenfinecoUsability13 = { version: '1.3.0', refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
